import React from 'react';
import PropTypes from 'prop-types';
import './FormGroup.css';

/**
 * FieldRow — fields side by side on a named split: '1:1' (first + last
 * name), '2:3' (postcode + city). Stays a row on phones too — a name or a
 * postcode never needs more than its share.
 */
const FieldRow = ({ columns = '1:1', className = '', children }) => (
  <div className={['ds-field-row', `ds-field-row--${columns.replace(':', '-')}`, className].filter(Boolean).join(' ')}>
    {children}
  </div>
);

FieldRow.propTypes = {
  columns: PropTypes.oneOf(['1:1', '2:3', '3:2', '1:2', '2:1']),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default FieldRow;
